import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { WorkAuthorPublisherListStore } from "../../store/WorkAuthorPublisherListStore";

type WorkAuthorPublisherListDialogsProps = {
  store: WorkAuthorPublisherListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de WorkAuthorPublisher.
 * Separado para mantener WorkAuthorPublisherListPage más limpio.
 */
export const WorkAuthorPublisherListDialogs: React.FC<WorkAuthorPublisherListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
